import moment from "moment";

function getFileDownloadURL(url: string) {
	return fetch(url)
		.then((response) => {
			return response.blob();
		})
		.then((blob) => {
			return URL.createObjectURL(blob);
		});
}

export const getFormattedDuration = (durationSeconds: number): string => {
	let durationMinutes = 0;

	if (durationSeconds > 0) {
		durationMinutes = durationSeconds / 60;
	}

	const durationString: string[] = [];
	const duration = moment.duration(durationMinutes, "minutes");

	if (!duration || duration.toISOString() === "P0D") return "0 minutes";

	if (duration.years() >= 1 && durationString.length < 2) {
		const years = Math.floor(duration.years());
		durationString.push(`${years} year${years > 1 ? "s" : ""}`);
	}

	if (duration.months() >= 1 && durationString.length < 2) {
		const months = Math.floor(duration.months());
		durationString.push(`${months} month${months > 1 ? "s" : ""}`);
	}

	if (duration.days() >= 1 && durationString.length < 2) {
		const days = Math.floor(duration.days());
		durationString.push(`${days} day${days > 1 ? "s" : ""}`);
	}

	if (duration.hours() >= 1 && durationString.length < 2) {
		const hours = Math.floor(duration.hours());
		durationString.push(`${hours} hour${hours > 1 ? "s" : ""}`);
	}

	if (duration.minutes() >= 1 && durationString.length < 2) {
		const minutes = Math.floor(duration.minutes());
		durationString.push(`${minutes} minute${minutes > 1 ? "s" : ""}`);
	}

	if (duration.seconds() >= 1 && durationString.length < 2) {
		const seconds = Math.floor(duration.seconds());
		durationString.push(`${seconds} second${seconds > 1 ? "s" : ""}`);
	}

	if (durationString.length <= 0) return "0 minutes";

	return durationString.join(", ");
};

export const convertSnakeToTitleCase = (text: string): string => {
	if (!text) return "";

	return text
		.toLowerCase()
		.split("_")
		.map((word) => word.replace(word[0], word[0].toUpperCase()))
		.join(" ");
};

export const convertToTitleCase = (text: string): string => {
	if (!text) return "";

	return text
		.toLowerCase()
		.split(" ")
		.map((word) => word.replace(word[0], word[0].toUpperCase()))
		.join(" ");
};

/**
 * Format a number (e.g. 100000 -> 1,00,000)
 * Pass `fractionDigits` to fix the number of decimal places (like `toFixed`)
 */
export const formatNumberMetric = (value: number | string | null | undefined, fractionDigits?: number): string => {
	const numericValue = Number(value);

	if (value === null || value === undefined || value === "" || Number.isNaN(numericValue)) {
		return String(value ?? "");
	}

	return new Intl.NumberFormat(
		"en-IN",
		fractionDigits === undefined
			? undefined
			: { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }
	).format(numericValue);
};

export const downloadFile =(fileBlob: Blob, fileName: string) => {
	const downloadUrl = URL.createObjectURL(fileBlob);
	const downloadLinkElement = document.createElement("a");

	downloadLinkElement.href = downloadUrl;
	downloadLinkElement.download = fileName;

	document.body.appendChild(downloadLinkElement);
	downloadLinkElement.click();

	URL.revokeObjectURL(downloadUrl);
	downloadLinkElement.parentNode?.removeChild(downloadLinkElement);
};

export const downloadImage = async (downloadURL: string, fileName: string) => {
	const downloadLinkElement = document.createElement("a");

	downloadLinkElement.href = downloadURL;
	downloadLinkElement.download = fileName;

	if (downloadURL.startsWith("http")) {
		downloadLinkElement.href = await getFileDownloadURL(downloadURL);
	}

	document.body.appendChild(downloadLinkElement);
	downloadLinkElement.click();

	URL.revokeObjectURL(downloadURL);
	downloadLinkElement.parentNode?.removeChild(downloadLinkElement);
};

/**
 * Remove reCAPTCHA script and badge after successful login
 */
export const removeRecaptchaScript = () => {
	// Remove reCAPTCHA script tag
	const recaptchaScript = document.querySelector('script[src*="recaptcha/api.js"]');
	if (recaptchaScript) {
		recaptchaScript.remove();
	}

	// Remove reCAPTCHA badge
	const recaptchaBadge = document.querySelector(".grecaptcha-badge");
	if (recaptchaBadge) {
		recaptchaBadge.remove();
	}

	// Clear grecaptcha from window object
	if (window.grecaptcha) {
		delete (window as any).grecaptcha;
	}
};
